import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './BannerAssociation.css';
import { FaArrowRight, FaUsers, FaHandsHelping, FaPlay, FaPause, FaVolumeUp, FaVolumeMute, FaStar } from 'react-icons/fa';
import videoSrc from '../../../assets/images/videoetefprincipale.mp4';

const BannerAssociation = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleVideoClick = (e) => {
    e.stopPropagation();
    togglePlay();
  };

  return (
    <section className="association-banner-section">
      {/* Effets de fond améliorés */}
      <div className="association-banner-overlay">
        <div className="association-banner-glow association-glow-1"></div>
        <div className="association-banner-glow association-glow-2"></div>
        <div className="association-banner-glow association-glow-3"></div>
        <div className="association-grid-pattern"></div>
      </div>
      
      <div className="association-banner-container">
        <div className="association-banner-content">
          <h1 className="association-banner-title">
            <span className="association-title-line accent-line">Réussissez vos études</span>
            <span className="association-title-line">en France avec ETEF</span>
          </h1>
          
          <p className="association-banner-subtitle">
            Nous facilitons l'intégration et le séjour des étudiants étrangers en France.
          </p>
          
          <div className="association-banner-actions">
            <Link 
              to="https://www.facebook.com/groups/516146849131280"
              className="association-cta-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Intégrer la communauté</span>
              <FaArrowRight className="association-cta-arrow" />
            </Link>
            
            <div className="association-trust-indicators">
              <div className="association-trust-item">
                <div className="association-trust-number">5K+</div>
                <div className="association-trust-label">Étudiants accompagnés</div>
              </div>
              <div className="association-trust-divider"></div>
              <div className="association-trust-item">
                <div className="association-trust-number">74%</div>
                <div className="association-trust-label">Taux de réussite</div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="association-banner-video">
          <div className="association-video-wrapper">
            <div className="association-video-container">
              <video 
                ref={videoRef}
                src={videoSrc} 
                className="association-video"
                autoPlay={false}
                muted={isMuted}
                loop
                playsInline
                onClick={handleVideoClick}
              />
              <div className="association-video-overlay"></div>
              
              {/* Contrôles vidéo améliorés */}
              <div className="video-controls-overlay">
                <button 
                  className="video-control-btn play-pause-btn"
                  onClick={togglePlay}
                  aria-label={isPlaying ? "Pause" : "Play"}
                >
                  {isPlaying ? <FaPause /> : <FaPlay />}
                </button>
                
                <button 
                  className="video-control-btn mute-btn"
                  onClick={toggleMute}
                  aria-label={isMuted ? "Activer le son" : "Désactiver le son"}
                >
                  {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
                </button>
              </div>
              
              {/* Indicateur d'état */}
              <div className={`video-state-indicator ${isPlaying ? 'playing' : 'paused'}`}>
                {isPlaying ? 'Lecture en cours' : 'Pause'}
              </div>
              
              {/* Badge sur la vidéo */}
              <div className="video-badge">
                <span>Depuis 2018</span>
              </div>
            </div>
            
            {/* Points forts sous la vidéo */}
            <div className="video-features">
              <div className="video-feature">
                <div className="feature-dot"></div>
                <span>Support personnalisé</span>
              </div>
              <div className="video-feature">
                <div className="feature-dot"></div>
                <span>Communauté active</span>
              </div>
              <div className="video-feature">
                <div className="feature-dot"></div>
                <span>Services gratuits</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerAssociation;